import { AlertTriangle } from 'lucide-react';
import type { ReactNode } from 'react';

export type WarningNoticeProps = {
  /** Texto do aviso; pode trazer ênfase (`<strong>`). */
  children: ReactNode;
  className?: string;
};

/** Aviso de atenção (laranja) com ícone, para regras que o usuário precisa saber antes de seguir. */
export function WarningNotice({
  children,
  className = '',
}: WarningNoticeProps) {
  return (
    <div
      role='note'
      className={`flex items-start gap-2 rounded-lg border border-alba-warning-orange-400 bg-alba-warning-orange-400/10 px-3 py-2 text-sm text-alba-gray-700 ${className}`}
    >
      <AlertTriangle
        aria-hidden='true'
        className='mt-0.5 h-4 w-4 shrink-0 text-alba-warning-orange-500'
        strokeWidth={1.8}
      />
      <div className='min-w-0'>{children}</div>
    </div>
  );
}
